module.exports = __webpack_public_path__ + "img/alxq7.311d55f6.png";